import { AtlBrowserStorageSession } from '@atlassian/browser-storage-controls/web-storage-service';
import { fg } from '@atlaskit/platform-feature-flags';

export const STICKY_SEARCH_KEY = 'atlassian.search-dialog-sticky';
export const SEARCH_QUERY_KEY = 'atlassian.search-dialog-query';
export const SEARCH_FILTERS_KEY = 'atlassian.search-dialog-filters';
export const SEARCH_SHOW_AI_DIALOG_KEY = 'atlassian.search-dialog.ai-dialog';

const getWindow = () => {
	if (typeof window === 'undefined') {
		return null;
	}
	if (typeof window.sessionStorage === 'undefined' && fg('fix_ssr_browser_storage_undefined')) {
		return null;
	}
	return window;
};

export const getSessionItem: (key: string) => string | null | undefined = (key: string) => {
	const windowReady = getWindow();
	if (!windowReady) {
		return null;
	}

	return fg('search_page_use_bsc_session_storage')
		? AtlBrowserStorageSession.getItem(key)
		: getWindow()?.sessionStorage.getItem(key);
};

export const setSessionItem: (key: string, value: string) => void = (
	key: string,
	value: string,
): void => {
	const windowReady = getWindow();
	if (!windowReady) {
		return;
	}

	try {
		if (fg('search_page_use_bsc_session_storage')) {
			AtlBrowserStorageSession.setItem(key, value);
		} else {
			getWindow()?.sessionStorage.setItem(key, value);
		}
	} catch (error: any) {
		if (error.code === DOMException.QUOTA_EXCEEDED_ERR) {
			// Do nothing if the sessionStorage capacity is reached
		} else {
		}
	}
};

export const deleteSessionItem: (key: string) => void = (key: string): void => {
	const windowReady = getWindow();
	if (!windowReady) {
		return;
	}

	if (fg('search_page_use_bsc_session_storage')) {
		AtlBrowserStorageSession.removeItem(key);
	} else {
		getWindow()?.sessionStorage.removeItem(key);
	}
};
